import React from 'react';
import DashboardLayout from '../components/layouts/DashboardLayout';

const Dashboard: React.FC = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  return (
    <DashboardLayout>
      <div className="max-w-4xl">
        <h1 className="text-3xl font-bold text-vyl-dark mb-8">
          Welcome back, {user.full_name || 'User'}!
        </h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {/* Profile Status Card */}
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-semibold text-vyl-dark">Profile Status</h3>
              <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
            </div>
            <p className="text-sm text-text-secondary mb-2">30% Complete</p>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div className="bg-yellow-400 h-2 rounded-full" style={{width: '30%'}}></div>
            </div>
          </div>

          {/* Team Status Card */}
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-semibold text-vyl-dark">Team Status</h3>
              <div className="w-3 h-3 bg-red-400 rounded-full"></div>
            </div>
            <p className="text-sm text-text-secondary">No team yet</p>
          </div>

          {/* Registration Status Card */}
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-semibold text-vyl-dark">Registration</h3>
              <div className="w-3 h-3 bg-red-400 rounded-full"></div>
            </div>
            <p className="text-sm text-text-secondary">Not started</p>
          </div>
        </div>

        {/* Next Steps */}
        <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
          <h3 className="font-semibold text-vyl-dark mb-4">Next Steps</h3>
          <div className="space-y-3">
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-vyl-dark text-white rounded-full flex items-center justify-center text-sm font-medium">1</div>
              <div>
                <p className="font-medium text-vyl-dark">Complete your profile</p>
                <p className="text-sm text-text-secondary">Add your personal information, occupation details, and social connections</p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-gray-300 text-gray-600 rounded-full flex items-center justify-center text-sm font-medium">2</div>
              <div>
                <p className="font-medium text-gray-600">Join or create a team</p>
                <p className="text-sm text-text-secondary">Find a teammate or create your own team for the competition</p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-gray-300 text-gray-600 rounded-full flex items-center justify-center text-sm font-medium">3</div>
              <div>
                <p className="font-medium text-gray-600">Complete registration</p>
                <p className="text-sm text-text-secondary">Register your team for the competition categories</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Dashboard;